export default {
    base: 'mx-auto w-full max-w-(--ui-container) px-4 sm:px-6 lg:px-8 xl:px-0',
};